export default function getTopics() {
  return [
    {
      label: "Properties",
      value: "PROPERTIES",
    },
    {
      label: "Consulting services",
      value: "CONSULTING-SERVICES",
    },
    {
      label: "Financing Facility",
      value: "FINANCING-FACILITY",
    },
    {
      label: "Relationship Management",
      value: "RELATIONSHIP-MANAGEMENT",
    },
    {
      label: "Others",
      value: "OTHERS",
    },
  ];
}
